import Common from '@/utils/common'

export function getInfo(data) {
  return Common.createRequest('merchant-api', 'MER0033', data)
}
// 创建操作员
export function createInfo(data) {
  return Common.createRequest('merchant-api', 'MER0201', data)
}
// 删除操作员
export function removeInfo(data) {
  return Common.createRequest('merchant-api', 'MER0301', data)
}
// 查看操作员
export function checkInfo(data) {
  return Common.createRequest('merchant-api', 'MER0036', data)
}
export function editInfo(data) {
  return Common.createRequest('merchant-api', 'MER0110', data)
}

export function searchUserRole(data) {
  return Common.createRequest('user-api', 'USER_ROLE_SEARCH', data)
}
export function changeUserRole(data) {
  return Common.createRequest('user-api', 'CHANGE_USER_ROLE', data)
}
